import { COUPON_CODES_SUCCESS, COUPON_CODES_FAILURE } from '../actions/types';

const defaultCouponCodesState = () => ({
    items: [],
    error: false,
});

/* eslint-disable import/prefer-default-export */
export const fetchCouponCodesReducer = (state = defaultCouponCodesState(), action) => {
    if (action.type === COUPON_CODES_SUCCESS) {
        const { payload: { default: defaultItems } } = action;

        return {
            ...state,
            items: defaultItems,
        };
    }

    if (action.type === COUPON_CODES_FAILURE) {
        return {
            ...state,
            ...action.payload,
            error: true,
        };
    }

    return state;
};
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/coupon-codes.js
 **/